<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" :model="searchForm" label-width="90px" size="mini">
        <el-form-item label="统计时间:">
          <el-select v-model="searchForm.timeSelect" placeholder="请选择" @change="onTimeChange" filterable style="width:180px">
            <el-option v-for="item in timeOptions" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分子公司:">
          <el-select v-model="searchForm.companyCode" filterable clearable placeholder="请选择" @change="zigsChangeCX">
            <el-option v-for="item in getCompany" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门:">
          <el-select v-model="searchForm.businessUnitCode" filterable clearable placeholder="请选择">
            <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称:">
           <el-input size="mini" v-model.trim="searchForm.customerName" placeholder=""></el-input>
        </el-form-item>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 时间范围提示 -->
    <div class="time-range-bar">
      <span class="period-tag">{{searchForm.timeSelect}}季度</span>
      <span class="time-range-text" v-if="searchForm.startTimeStr">统计时间范围：{{ searchForm.startTimeStr }} 至 {{ searchForm.endTimeStr }}</span>
    </div>
    <!--  表格 -->
    <div class="table">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" highlight-current-row
      center border show-summary :summary-method="getSummaries" :span-method="objectSpanMethod" :cell-class-name="cellClassName">
        <el-table-column type="index" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="createSubcompanyName" label="分子公司" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="businessUnit" label="部门" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="payee" label="客户名称" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <!-- 去年同期 -->
        <el-table-column label="去年同期" align="center">
          <el-table-column prop="lastYearLiquidatedAmountSum" label="业务量" min-width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="lastYearGrossNoRevenueSum" label="不含税收入" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="lastYearFreightNoTaxTotalSum" label="不含税支出" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="lastYearMlrAmount" label="毛利" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        </el-table-column>
        <!-- 上期 -->
        <el-table-column label="上期" align="center">
          <el-table-column prop="upLiquidatedAmountSum" label="业务量" min-width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="upGrossNoRevenueSum" label="不含税收入" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="upFreightNoTaxTotalSum" label="不含税支出" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="upMlrAmount" label="毛利" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        </el-table-column>
        <!-- 本期 -->
        <el-table-column label="本期" align="center">
          <el-table-column prop="currLiquidatedAmountSum" label="业务量" min-width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="currGrossNoRevenueSum" label="不含税收入" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="currFreightNoTaxTotalSum" label="不含税支出" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="currMlrAmount" label="毛利" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        </el-table-column>
        <!-- 同比数值（占位，字段名待定） -->
        <el-table-column label="同比数值" align="center">
          <el-table-column prop="sameValueLiquidatedAmountSum" label="业务量" min-width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="sameValueGrossNoRevenueSum" label="不含税收入" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="sameValueFreightNoTaxTotalSum" label="不含税支出" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="sameValueMlrAmount" label="毛利" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        </el-table-column>
        <!-- 同比% -->
        <el-table-column label="同比%" align="center">
          <el-table-column prop="sameRatioLiquidatedAmountSum" label="业务量" min-width="100" :show-overflow-tooltip="true" :formatter="formatPercent"></el-table-column>
          <el-table-column prop="sameRatioGrossNoRevenueSum" label="不含税收入" min-width="100" :show-overflow-tooltip="true" :formatter="formatPercent"></el-table-column>
          <el-table-column prop="sameRatioFreightNoTaxTotalSum" label="不含税支出" min-width="100" :show-overflow-tooltip="true" :formatter="formatPercent"></el-table-column>
          <el-table-column prop="sameRatioMlrAmount" label="毛利" min-width="100" :show-overflow-tooltip="true" :formatter="formatPercent"></el-table-column>
        </el-table-column>
        <!-- 环比数值（占位，字段名待定） -->
        <el-table-column label="环比数值" align="center">
          <el-table-column prop="monthValueLiquidatedAmountSum" label="业务量" min-width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="monthValueGrossNoRevenueSum" label="不含税收入" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="monthValueFreightNoTaxTotalSum" label="不含税支出" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="monthValueMlrAmount" label="毛利" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        </el-table-column>
        <!-- 环比% -->
        <el-table-column label="环比%" align="center">
          <el-table-column prop="monthRatioLiquidatedAmountSum" label="业务量" min-width="100" :show-overflow-tooltip="true" :formatter="formatPercent"></el-table-column>
          <el-table-column prop="monthRatioGrossNoRevenueSum" label="不含税收入" min-width="100" :show-overflow-tooltip="true" :formatter="formatPercent"></el-table-column>
          <el-table-column prop="monthRatioFreightNoTaxTotalSum" label="不含税支出" min-width="100" :show-overflow-tooltip="true" :formatter="formatPercent"></el-table-column>
          <el-table-column prop="monthRatioMlrAmount" label="毛利" min-width="100" :show-overflow-tooltip="true" :formatter="formatPercent"></el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { businessAnalysis, findCustomerInfoList } from '@/api/newTMS'
import { getCurrUserDepartment, getCurrUserRightCompany } from '@/api/newCrm'
import { toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
const rationProps = [
  'weightUpRation', 'weightYearRation',
  'grossNoRevenueUpRation', 'grossNoRevenueYearRation',
  'freightNoTaxTotalUpRation', 'freightNoTaxTotalYearRation',
  'upMlrAmountRation', 'yearMlrAmountRation'
]
// 环比/同比列 → 对应的本期/对比期字段
const rationMap = {
  'weightUpRation': { curr: 'currLiquidatedAmountSum', compare: 'upLiquidatedAmountSum' },
  'weightYearRation': { curr: 'currLiquidatedAmountSum', compare: 'lastYearLiquidatedAmountSum' },
  'grossNoRevenueUpRation': { curr: 'currGrossNoRevenueSum', compare: 'upGrossNoRevenueSum' },
  'grossNoRevenueYearRation': { curr: 'currGrossNoRevenueSum', compare: 'lastYearGrossNoRevenueSum' },
  'freightNoTaxTotalUpRation': { curr: 'currFreightNoTaxTotalSum', compare: 'upFreightNoTaxTotalSum' },
  'freightNoTaxTotalYearRation': { curr: 'currFreightNoTaxTotalSum', compare: 'lastYearFreightNoTaxTotalSum' },
  'upMlrAmountRation': { curr: 'currMlrAmount', compare: 'upMlrAmount' },
  'yearMlrAmountRation': { curr: 'currMlrAmount', compare: 'yearMlrAmount' }
}
// 同比/环比数值字段（不参与求和，按差值计算）
const diffProps = [
  'yearDiffLiquidatedAmountSum', 'yearDiffGrossNoRevenueSum', 'yearDiffFreightNoTaxTotalSum', 'yearDiffMlrAmount',
  'upDiffLiquidatedAmountSum', 'upDiffGrossNoRevenueSum', 'upDiffFreightNoTaxTotalSum', 'upDiffMlrAmount'
]
// 同比/环比数值列 → 对应本期/对比期字段
const diffMap = {
  'yearDiffLiquidatedAmountSum': { curr: 'currLiquidatedAmountSum', compare: 'lastYearLiquidatedAmountSum' },
  'yearDiffGrossNoRevenueSum': { curr: 'currGrossNoRevenueSum', compare: 'lastYearGrossNoRevenueSum' },
  'yearDiffFreightNoTaxTotalSum': { curr: 'currFreightNoTaxTotalSum', compare: 'lastYearFreightNoTaxTotalSum' },
  'yearDiffMlrAmount': { curr: 'currMlrAmount', compare: 'yearMlrAmount' },
  'upDiffLiquidatedAmountSum': { curr: 'currLiquidatedAmountSum', compare: 'upLiquidatedAmountSum' },
  'upDiffGrossNoRevenueSum': { curr: 'currGrossNoRevenueSum', compare: 'upGrossNoRevenueSum' },
  'upDiffFreightNoTaxTotalSum': { curr: 'currFreightNoTaxTotalSum', compare: 'upFreightNoTaxTotalSum' },
  'upDiffMlrAmount': { curr: 'currMlrAmount', compare: 'upMlrAmount' }
}
// 季度 → 起止月
const quarterMap = {
  1: { start: 1, end: 3 },
  2: { start: 4, end: 6 },
  3: { start: 7, end: 9 },
  4: { start: 10, end: 12 }
}
// 健壮的数字解析：处理逗号、空格、null等
function parseNumber (val) {
  if (val === null || val === undefined || val === '') return NaN
  if (typeof val === 'number') return val
  const str = String(val).trim().replace(/[,，]/g, '')
  return Number(str)
}
export default {
  name: 'Jidu',
  data () {
    return {
      searchForm: {
        startTimeStr: '',
        endTimeStr: '',
        companyCode: '',
        departmentCode: '',
        customerName: '',
        queryType: 2,
        timeSelect: ''
      },
      tableList: [],
      spanArr: [],
      h: '',
      isDaoChu: false,
      getCompany: [],
      bumenList: []
    }
  },
  computed: {
    timeOptions () {
      const now = new Date()
      const currentYear = now.getFullYear()
      const currentQuarter = Math.floor(now.getMonth() / 3) + 1
      const quarterNames = ['第一季度', '第二季度', '第三季度', '第四季度']
      const arr = []
      for (let y = 2025; y <= currentYear; y++) {
        const maxQ = (y === currentYear) ? currentQuarter : 4
        for (let q = 1; q <= maxQ; q++) {
          arr.push({ label: `${y}年${quarterNames[q - 1]}`, value: `${y}-${q}` })
        }
      }
      return arr
    }
  },
  created () {
    const now = new Date()
    this.searchForm.timeSelect = `${now.getFullYear()}-${Math.floor(now.getMonth() / 3) + 1}`
    this.onTimeChange()
    getCurrUserRightCompany().then(res => { this.getCompany = res })
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 220 + 'px'
  },
  methods: {
    // 选择时间变化时计算 startTimeStr / endTimeStr
    onTimeChange () {
      const val = this.searchForm.timeSelect
      if (!val) {
        this.searchForm.startTimeStr = ''
        this.searchForm.endTimeStr = ''
        return
      }
      const [y, q] = val.split('-')
      const { start, end } = quarterMap[Number(q)]
      const lastDay = new Date(Number(y), end, 0).getDate()
      this.searchForm.startTimeStr = `${y}-${String(start).padStart(2, '0')}-01 00:00:00`
      this.searchForm.endTimeStr = `${y}-${String(end).padStart(2, '0')}-${String(lastDay).padStart(2, '0')} 23:59:59`
    },
    zigsChangeCX (e) {
      getCurrUserDepartment({ compayCode: e, isQueryDept: 0 }).then(res => { this.bumenList = res })
      this.$set(this.searchForm, 'businessUnitCode', '')
    },
    formatPercent (row, column, cellValue) {
      if (cellValue === null || cellValue === undefined || cellValue === '') return '-'
      const str = String(cellValue)
      if (str.includes('%')) return str
      const num = Number(cellValue)
      if (isNaN(num)) return str
      return toFixed(num, 2) + '%'
    },
    cellClassName ({ row, column }) {
      if (rationProps.includes(column.property) || diffProps.includes(column.property)) {
        let raw = row[column.property]
        if (raw === null || raw === undefined || raw === '') return ''
        let str = String(raw).replace('%', '').trim()
        const val = Number(str)
        if (!isNaN(val) && val < 0) {
          return 'ration-negative'
        }
      }
      return ''
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      // 先算所有非环比/同比数值列的合计
      const colSums = {}
      columns.forEach((column) => {
        if (column.property && !rationProps.includes(column.property) &&
            !diffProps.includes(column.property) &&
            !['createSubcompanyName', 'businessUnit', 'payee'].includes(column.property)) {
          const values = data.map(item => parseNumber(item[column.property]))
          colSums[column.property] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) return prev + curr
            return prev
          }, 0)
        }
      })
      columns.forEach((column, index) => {
        if (!column.property) { sums[index] = ''; return }
        if (column.property === 'createSubcompanyName') { sums[index] = '合计'; return }
        if (['businessUnit', 'payee'].includes(column.property)) { sums[index] = '-'; return }
        if (rationProps.includes(column.property)) {
          const { curr, compare } = rationMap[column.property]
          const currSum = colSums[curr] || 0
          const compareSum = colSums[compare] || 0
          if (compareSum === 0) {
            sums[index] = '-'
          } else {
            sums[index] = toFixed(((currSum - compareSum) / compareSum) * 100, 2) + '%'
          }
          return
        }
        if (diffProps.includes(column.property)) {
          const { curr, compare } = diffMap[column.property]
          const currSum = colSums[curr] || 0
          const compareSum = colSums[compare] || 0
          sums[index] = currSum - compareSum
          return
        }
        sums[index] = colSums[column.property]
      })
      return sums.map(item => {
        if (typeof item === 'number') return toFixed(item, 2)
        return item
      })
    },
    getgaodu () {
      this.$nextTick(() => {
        if (this.$refs.searchBox) {
          let h = this.$refs.searchBox.offsetHeight
          let pH = document.documentElement.clientHeight
          this.h = (pH - h - 220) + 'px'
          if (this.$refs.table) this.$refs.table.doLayout()
        }
      })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'createSubcompanyName' || column.property === 'businessUnit') {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return { rowspan: _row, colspan: _col }
      }
      return [1, 1]
    },
    getSpanArr (data) {
      this.spanArr = []
      let pos = 0
      data.forEach((item, index) => {
        if (index === 0) { this.spanArr.push(1); pos = 0 } else if (item.businessUnit === data[index - 1].businessUnit &&
                 item.createSubcompanyName === data[index - 1].createSubcompanyName) {
          this.spanArr[pos] += 1; this.spanArr.push(0)
        } else { this.spanArr.push(1); pos = index }
      })
    },
    masterList () {
      const loading = this.$loading({ lock: true, text: '加载中...' })
      businessAnalysis(this.searchForm)
        .then(res => {
          this.tableList = res || []
          this.getSpanArr(this.tableList)
          this.getgaodu()
          loading.close()
        })
        .catch(err => {
          this.$message({ showClose: true, message: err.message, type: 'error', onClose () { loading.close() } })
        })
    },
    searchFn () {
      if (!this.searchForm.startTimeStr || !this.searchForm.endTimeStr) {
        this.$message.warning('请选择签收时间'); return
      }
      this.masterList()
    },
    resetForm () {
      const now = new Date()
      this.searchForm.timeSelect = `${now.getFullYear()}-${Math.floor(now.getMonth() / 3) + 1}`
      this.onTimeChange()
      this.searchForm.companyCode = ''
      this.searchForm.departmentCode = ''
      this.searchForm.customerName = ''
      this.bumenList = []
      this.searchFn()
    },
    exportFn () {
      if (!this.searchForm.startTimeStr || !this.searchForm.endTimeStr) {
        this.$message.warning('请选择签收时间'); return
      }
      let form = { ...this.searchForm }
      delete form.timeSelect
      exportExcel(this.global.tmsPlus + '/rCustomer/exportBusinessAnalysisReport', form, '业务分析报表-季度')
      this.isDaoChu = true
      setTimeout(() => { this.isDaoChu = false }, 2000)
    }
  }
}
</script>
<style scoped lang="less">
.app-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.formBox {
  flex-shrink: 0;
}
.time-range-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 10px;
  background: #f0f6ff;
  border-radius: 4px;
  .period-tag {
    display: inline-block;
    padding: 2px 12px;
    background: #1890ff;
    color: #fff;
    border-radius: 3px;
    font-size: 13px;
    font-weight: bold;
    margin-right: 16px;
  }
  .time-range-text {
    font-size: 13px;
    color: #606266;
  }
}
.table {
  flex: 1;
  overflow: hidden;
}
/deep/ .el-table td.ration-negative .cell {
  overflow: visible !important;
}
/deep/ .el-table td.ration-negative .cell::after {
  content: ' ↓';
  color: #F56C6C;
  font-weight: bold;
  font-size: 14px;
}
</style>
